import { Link } from "react-router-dom";
import { CITY_PAGES, CITY_INFO } from "@/data/cityPages";
import { useSeo, SITE_URL } from "@/lib/seo";
import { MapPin, ArrowRight } from "lucide-react";

const CITIES = Object.keys(CITY_INFO);
const jsonLd = {
  "@context": "https://schema.org", "@type": "ItemList", name: "InspectorProLeads service areas",
  itemListElement: CITY_PAGES.map((p, i) => ({ "@type": "ListItem", position: i + 1, name: p.title, url: `${SITE_URL}/services/${p.slug}` })),
};

export default function ServiceAreas() {
  useSeo({
    title: "Service Areas: Sacramento & Placer County Home-Service Pros | InspectorProLeads",
    description: "Find verified home inspectors, pest control, roofing, HVAC and contractors in Sacramento, Elk Grove, Roseville, Folsom, Rocklin and more. Free quotes.",
    path: "/services", jsonLd,
  });
  return (
    <div className="container-x py-14" data-testid="service-areas-page">
      <div className="max-w-2xl mb-12">
        <span className="text-xs font-mono uppercase tracking-wider text-[color:var(--emerald)]">Service Areas</span>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-[color:var(--navy)] mt-2">Local pros across Sacramento & Placer County</h1>
        <p className="text-[color:var(--ink-2)] mt-4">Pick your city and service to see local tips and get free quotes from verified pros.</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {CITIES.map((city) => (
          <div key={city} className="card-soft p-6" data-testid={`service-area-${city.toLowerCase().replace(/\s+/g, "-")}`}>
            <h2 className="font-display text-xl font-bold text-[color:var(--navy)] flex items-center gap-2"><MapPin className="w-4 h-4 text-[color:var(--emerald)]" /> {city}</h2>
            <p className="text-xs text-[color:var(--ink-3)] mt-1">{CITY_INFO[city].county}</p>
            <ul className="mt-4 space-y-2">{CITY_PAGES.filter((p) => p.city === city).map((p) => (
              <li key={p.slug}><Link to={`/services/${p.slug}`} data-testid={`service-link-${p.slug}`} className="text-sm text-[color:var(--ink-2)] hover:text-[color:var(--emerald)] flex items-center gap-1 transition-colors">{p.title.replace(`, CA`, "").replace(` in ${city}`, "")} <ArrowRight className="w-3 h-3" /></Link></li>))}</ul>
          </div>
        ))}
      </div>
    </div>
  );
}
